
import Vue from 'vue'
import AppMixin from '@/_mixins/app'

import { ProjectUser } from '@/views/Authorization/types/projectUser'
import { HseContact } from '@/views/Project/HSE/types/hseContact'
import UserAvatar from '@/views/User/components/userAvatar.vue'
import { postHseContactsWithUser } from '../../../../utils/hse'

const ProjectUserTr = Vue.extend({
    mixins: [AppMixin],
    components: { UserAvatar },
    props: {
        projectUser: {
            type: Object as () => ProjectUser,
            required: true,
        },
        hseContacts: {
            type: Array as () => HseContact[],
            required: true,
        },
        searchTerm: {
            type: String,
            required: true,
        },
        debounceisOn: {
            type: Boolean,
            required: true,
        },
    },

    data() {
        return {
            loading: false,
            snackbar: {
                value: false,
                text: '' as any,
                timeout: 5000,
                color: 'grey darken-3',
            },
        }
    },

    computed: {
        company() {
            return this.projectUser['projectContractor']
        },
        mail() {
            if (this.projectUser.user.data) {
                return this.projectUser.user.data.primaryEmail
            } else {
                return this.projectUser.email
            }
        },
        mobile() {
            if (this.projectUser.user.data) {
                return this.projectUser.user.data.mobileNumber
            } else {
                return this.projectUser.mobile
            }
        },
        phone() {
            if (this.projectUser.user.data) {
                return this.projectUser.user.data.phoneNumber
            } else {
                return null
            }
        },
        hseAddBtnAvailable() {
            return (
                !!this.projectUser.user.data &&
                (this.mobile || this.phone) &&
                this.currentProject &&
                this.currentProject.attributes.constraints.hseContacts.writable &&
                this.hseContacts.findIndex(
                    (hseContact) => hseContact.user.data?.id === this.projectUser.user.data?.id
                ) === -1
            )
        },
    },

    methods: {
        async addToHSE() {
            if (this.projectUser.user.data) {
                this.loading = true
                try {
                    let newHseContact = await postHseContactsWithUser(
                        this.currentProjectId,
                        this.projectUser.user.data.id
                    )
                    this.$emit('hseContactAdded', newHseContact)
                    this.snackbar.value = true
                    this.snackbar.text = this.$t(
                        'authorization_fe["contacts.add_user_to_hse_contacts_success"]',
                        { user: this.projectUser.user.data.name }
                    )
                } catch (e) {
                    this.snackbar.value = true
                    this.snackbar.color = 'error'
                    this.snackbar.timeout = -1
                    this.snackbar.text = this.$t(
                        'authorization_fe["contacts.add_user_to_hse_contacts_error"]',
                        { user: this.projectUser.user.data.name }
                    )
                } finally {
                    this.loading = false
                }
            }
        },
    },
})

export default ProjectUserTr
